import React from 'react';
import { 
  ToggleButtonGroup, 
  ToggleButton, 
  Box, 
  useTheme, 
  styled 
} from '@mui/material';
import { alpha } from '@mui/material/styles';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  width:'100%',
  borderRadius: theme.shape.borderRadius * 1.5,
  backgroundColor: alpha(theme.palette.secondary.main, 0.06),
  border: `1px solid ${alpha(theme.palette.secondary.main, 0.12)}`,
  padding: 4,
  gap: 4,
  boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.08)}`,
  '& .MuiToggleButtonGroup-grouped': {
    margin: 0,
    border: 0,
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
      marginLeft: 0,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
    },
  },
  '& .MuiToggleButton-root': {
    borderRadius: theme.shape.borderRadius,
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '1.2rem',
    padding: '10px 20px',
    color: theme.palette.text.secondary,
    border: 'none',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    minWidth: 80,
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
      fontWeight: 600,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    '&:not(.Mui-selected)': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        color: theme.palette.primary.main,
      },
    },
  },
}));

const UIModeToggle = ({ value, onChange, options }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        py: 3,
        // px: 2,
        width:'100%'
      }}
    >
      <StyledToggleButtonGroup
        value={value}
        exclusive
        onChange={onChange}
        aria-label="UI mode toggle"
      >
        {options.map((option) => (
          <ToggleButton 
            key={option.value} 
            value={option.value}
            aria-label={option.label}
          >
            {option.label}
          </ToggleButton>
        ))}
        {/* <p style={{padding:'7px 0 5px 0', color: '#EAA221', fontSize:'1.5em'}}>🌐 The content of this page is still being updated. Feel free to contact the IT team if you have any comments 😊</p> */}
      </StyledToggleButtonGroup>
      
    </Box>
  );
};

export default UIModeToggle;